import {OtsUIState} from "../../ots-ui-store";

export const selectUIInvoiceSearchFilter = (state: OtsUIState) => state.uiInvoice.searchFilter
